import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=2fc9b20d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=2fc9b20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9b20d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc9b20d')) {
      api.createRecord('2fc9b20d', component.options)
    } else {
      api.reload('2fc9b20d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=2fc9b20d&scoped=true&", function () {
      api.rerender('2fc9b20d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J6W0v6xZznwA/JS/comp/PopupBox.vue"
export default component.exports